import React from 'react';
import { DashboardV3ProjectHeaderHero } from './DashboardV3ProjectHeaderHero';

export type DashboardV3ProjectHeaderProps = {
    theme: 'dark' | 'light';
    opportunityName: string;
    opportunityId: string;
    stageStatus: string;
    siteAddress?: string | null;
    utilityCompany: string;
    loading?: boolean;
    /** V2 split dashboard: quick-action deck in lead panel. Off for V3 layout. */
    showActionDeck?: boolean;
    isTitleContactExist?: boolean | null;
    onAddTitleContactsClick?: () => void;
    onBlackKnightTitleCheckClick?: () => void;
};

export const DashboardV3ProjectHeader: React.FC<DashboardV3ProjectHeaderProps> = (props) => {
    return <DashboardV3ProjectHeaderHero {...props} />;
};

export { triggerV3AiDesignsPanel } from './dashboardV3AiDesignsTrigger';
